import { Standing } from 'types'
import { StandingsTableRow } from '../StandingsTableRow/StandingsTableRow'
import * as Styled from './StandingsTable.styled'

export function StandingsTable({ standings }: { standings: Standing[] }) {
  return (
    <Styled.Table>
      <thead>
        <Styled.TheadRow>
          <Styled.TH>R</Styled.TH>
          <Styled.TH>Organization</Styled.TH>
          <Styled.TH>W</Styled.TH>
          <Styled.TH>L</Styled.TH>
          <Styled.TH>T</Styled.TH>
          <Styled.TH>%</Styled.TH>
          <Styled.TH>HOME</Styled.TH>
          <Styled.TH>AWAY</Styled.TH>
          <Styled.TH>PF</Styled.TH>
          <Styled.TH>PA</Styled.TH>
          <Styled.TH>+-</Styled.TH>
          <Styled.TH>ST</Styled.TH>
        </Styled.TheadRow>
      </thead>
      <tbody>
        {standings.map((standing, index) => {
          return <StandingsTableRow key={standing.id} standing={standing} index={index} />
        })}
      </tbody>
    </Styled.Table>
  )
}
